// Reads the Bull job id gql-service stores on a hashedEmailList's
// `dspSegmentIds` JSON field once a Nexxen publish has been triggered, e.g.
//   [{ segmentId: "mediajel-hem-…", segmentName: "…", jobId: "42" }]
//
// This is the persisted signal that a publish is (or was) in flight for an
// audience. Unlike `stepProgress === 2`, it survives a page reload — it
// comes from the DB via GET_HASHED_EMAIL_LIST, not from component/session
// state — and it doesn't false-positive on legacy records that can sit at
// stepProgress 2 without ever having gone through the new pipeline (they
// have no jobId at all).
//
// Never throws: `dspSegmentIds` can be null/undefined, a non-array, an
// empty array, contain non-object entries, or contain objects with no
// `jobId`.
export const getPublishJobId = (dspSegmentIds) => {
  if (!Array.isArray(dspSegmentIds)) return null;

  const entryWithJobId = dspSegmentIds.find(
    (entry) => entry && typeof entry === "object" && entry.jobId
  );

  return entryWithJobId ? entryWithJobId.jobId : null;
};

export default getPublishJobId;
